declare let projectData;
declare let navigationData;
declare let previousReferenceUrl;
declare let nextReferenceUrl;

export const getProjectData = () => {
    if (typeof projectData != "undefined")
        return projectData;
    return {}
};


export const getPreviousReferenceUrl = () => {
    if (typeof previousReferenceUrl != "undefined")
        return previousReferenceUrl;
    return {}
};

export const getNextReferenceUrl = () => {
    if (typeof nextReferenceUrl != "undefined")
        return nextReferenceUrl;
    return {}
};



